module.exports = __webpack_public_path__ + "img/20231221.618d2dbc.jpg";